import React from 'react';
import { NavLink } from 'react-router-dom';
import { SettingsIcon } from '../Icons';

const DocComponent = props => {
  return (
    <li className="nav-item">
      <NavLink
        onClick={props.onClick}
        to={props.link}
        activeClassName="active"
        className="vertical-nav-hover nav-link text-dark rounded-lg text-decoration-none"
      >
        <SettingsIcon fill="#202020" />
        Settings
      </NavLink>
    </li>
  );
};
export default DocComponent;
